import { Action } from '@ngrx/store';
import { ICategory } from '../../model';

// HTTP CRUD

//  CRUD
export enum CategoryActionsType {
  LOAD_HTTP = '[Category] Load Http',
  LOAD_HTTP_SUCCESS = '[Category] Load Http Success',
  LOAD_HTTP_FAIL = '[Category] Load Http Fail',

  LOAD_TAG_HTTP = '[Category] Load Tag Http',
  LOAD_TAG_HTTP_SUCCESS = '[Category] Load Tag Http Success',
  LOAD_TAG_HTTP_FAIL = '[Category] Load Tag Http Fail',

  LOAD_PUBLIC_HTTP = '[Category] Load Public Http',
  LOAD_PUBLIC_HTTP_SUCCESS = '[Category] Load Http Public Success',
  LOAD_PUBLIC_HTTP_FAIL = '[Category] Load Public Http Fail',

  ADD_HTTP = '[Category] Add Http',
  UPDATE_HTTP = '[Category] Update Http',
  ADD_UPDATE_HTTP_SUCCESS = '[Category] Add Update Http Success',
  ADD_UPDATE_HTTP_FAIL = '[Category] Add Update Http Fail',

  DELETE_HTTP = '[Category] Delete Http',
  DELETE_HTTP_SUCCESS = '[Category] Delete Http Success',
  DELETE_HTTP_FAIL = '[Category] Delete Http Fail',

  UPDATE_DATA_LENGTH = '[Category] Update Data Length',
  UPDATE_OFFSET = '[Category] Update Offset',
  UPDATE_LIMIT = '[Category] Update Limit',

  UPDATE_SEARCH = '[Category] Update Search',

}

export class LoadHttp implements Action {
  
  readonly type = CategoryActionsType.LOAD_HTTP;
  constructor(public payload: any) {}
}

export class LoadHttpSuccess implements Action {
  readonly type = CategoryActionsType.LOAD_HTTP_SUCCESS;
  constructor(public payload: ICategory[]) {}
}
export class LoadHttpFail implements Action {
  readonly type = CategoryActionsType.LOAD_HTTP_FAIL;
  constructor(public error: any) {}
}

export class LoadTagHttp implements Action {
  
  readonly type = CategoryActionsType.LOAD_TAG_HTTP;
  constructor(public payload: any) {
  }
}

export class LoadTagHttpSuccess implements Action {
  readonly type = CategoryActionsType.LOAD_TAG_HTTP_SUCCESS;
  constructor(public payload: any) {}
}
export class LoadTagHttpFail implements Action {
  readonly type = CategoryActionsType.LOAD_TAG_HTTP_FAIL;
  constructor(public error: any) {}
}

export class LoadPublicHttp implements Action {
  readonly type = CategoryActionsType.LOAD_PUBLIC_HTTP;
  constructor() {}
}

export class LoadPublicHttpSuccess implements Action {
  readonly type = CategoryActionsType.LOAD_PUBLIC_HTTP_SUCCESS;
  constructor(public payload: ICategory[]) {}
}
export class LoadPublicHttpFail implements Action {
  readonly type = CategoryActionsType.LOAD_PUBLIC_HTTP_FAIL;
  constructor(public error: any) {}
}

export class AddHttp implements Action {
  readonly type = CategoryActionsType.ADD_HTTP;
  constructor(public payload: ICategory) {}
}

export class UpdateHttp implements Action {
  readonly type = CategoryActionsType.UPDATE_HTTP;
  constructor(public payload: ICategory) {}
}

export class AddUpdateHttpSuccess implements Action {
  readonly type = CategoryActionsType.ADD_HTTP;
  // comes from effect
  constructor(public payload: ICategory) {}
}
export class AddUpdateHttpFail implements Action {
  readonly type = CategoryActionsType.ADD_UPDATE_HTTP_FAIL;
  constructor(public error: any) {}
}

export class DeleteHttp implements Action {
  readonly type = CategoryActionsType.DELETE_HTTP;
  constructor(public countryId: number) {}
}

export class DeleteHttpSuccess implements Action {
  readonly type = CategoryActionsType.DELETE_HTTP_SUCCESS;
  constructor(public payload: any) {}
}

export class DeleteHttpFail implements Action {
  readonly type = CategoryActionsType.DELETE_HTTP_FAIL;
  constructor(public error: any) {}
}

export class UpdateDataLength implements Action {
  readonly type = CategoryActionsType.UPDATE_DATA_LENGTH;
  constructor(public dataLength: number) {}
}

export class UpdateOffset implements Action {
  readonly type = CategoryActionsType.UPDATE_OFFSET;
  constructor() {}
}
export class UpdateLimit implements Action {
  readonly type = CategoryActionsType.UPDATE_LIMIT;
  constructor(public limit: number) {}
}
export class UpdateSearch implements Action {
  readonly type = CategoryActionsType.UPDATE_SEARCH;
  constructor(public search: any) { }
}

export type CategoryActions =
  | LoadHttp
  | LoadHttpSuccess
  | LoadHttpFail
  | LoadTagHttp
  | LoadTagHttpSuccess
  | LoadTagHttpFail
  | LoadPublicHttp
  | LoadPublicHttpSuccess
  | LoadPublicHttpFail
  | AddHttp
  | UpdateHttp
  | AddUpdateHttpSuccess
  | AddUpdateHttpFail
  | DeleteHttp
  | DeleteHttpSuccess
  | DeleteHttpFail
  | UpdateDataLength
  | UpdateOffset
  | UpdateLimit
  | UpdateSearch;
